import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { themeColors } from "./themeConfig";

const useStylesThemes = () => {
  const lightenColor = (color, percent) => {
    const num = parseInt(color.replace("#", ""), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = ((num >> 8) & 0x00ff) + amt,
      B = (num & 0x0000ff) + amt;
    return (
      "#" +
      (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
        .toString(16)
        .slice(1)
    );
  };

  const themeName =
    useSelector((state) => state.manif?.manifParams?.Theme) || "theme1";

  const headerColor = themeColors[themeName].headerColor;
  const color = themeColors[themeName].color;
  const validateColor = themeColors[themeName].validateColor;

  return makeStyles((theme) => ({
    validateButton: {
      backgroundColor: validateColor,
      color: color,
      "&:hover": {
        backgroundColor: lightenColor(validateColor, 10),
      },
    },
    primarybutton: {
      backgroundColor: headerColor,
      color: color,
      "&:hover": {
        backgroundColor: lightenColor(headerColor, 10),
      },
    },
    secondarybutton: {
      backgroundColor: color,
      color: headerColor,
      "&:hover": {
        backgroundColor: "#f1f1f1",
      },
    },
    badge: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      backgroundColor: headerColor,
      color: color,
      width: 32,
      height: 32,
    },
    badgeRefus: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      backgroundColor: "red",
      color: "white",
      width: 32,
      height: 32,
    },
    iconColor: {
      color: headerColor,
      pointerEvents: "auto",
    },
    modalTitle: {
      backgroundColor: headerColor,
      color: color,
      fontSize: "1.2em !important",
      "& h2": {
        fontSize: "1.4em",
      },
    },
    modalStyle: {
      "& .MuiDialog-paper": {
        borderRadius: 8,
        overflow: "hidden",
      },
    },
  }));
};

export default useStylesThemes;
